import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as taxNumbersMainReducer from '../reducers';
import * as fromTaxNumbers from '../reducers/tax-numbers.reducer';

export const selectTaxNumbers = createSelector(
  taxNumbersMainReducer.GetTaxNumbersState,
  fromTaxNumbers.getTaxNumbers
);